import TumengNavigator from './src/index.vue'

TumengNavigator.install = function(Vue) {
  Vue.component(TumengNavigator.name, TumengNavigator)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengNavigator)
}

export default TumengNavigator
